import React from 'react';
import { Search, Info } from 'lucide-react';
import { cn } from '@/utils/cn';
import { navTestId } from '@/utils/testId';
import { Tooltip } from '@/components/ui/Tooltip';

interface AppTopbarProps {
  tab?: string;
  onTab?: (tab: string) => void;
  tabs?: Array<{ value: string; label: string }>;
  contractPicker?: React.ReactNode;
}

const AppTopbar: React.FC<AppTopbarProps> = ({ tab, onTab, tabs = [], contractPicker }) => {
  return (
    <div
      className="h-14 flex items-stretch px-4 relative z-[1] text-chrome-bar-fg"
      style={{ background: 'color-mix(in srgb, var(--chrome-bar), black 4%)' }}
    >
      {contractPicker && (
        <div className="flex items-center pr-4 border-r border-chrome-bar-line shrink-0">
          {contractPicker}
        </div>
      )}

      <div className="flex-1 flex items-center pl-4 gap-6">
        {tabs.map((t) => (
          <button
            key={t.value}
            onClick={() => onTab?.(t.value)}
            data-testid={`topbar-tab-${navTestId(t.label, t.value)}-btn`}
            className={cn(
              'relative h-9 text-sm font-medium tracking-wide transition-colors',
              tab === t.value
                ? 'text-chrome-bar-fg-active'
                : 'text-chrome-bar-fg-dim hover:text-chrome-bar-fg-active'
            )}
          >
            {t.label}
            {tab === t.value && (
              <span className="absolute left-1/2 -bottom-2 -translate-x-1/2 h-1 w-8 rounded-full bg-chrome-bar-accent" />
            )}
          </button>
        ))}
      </div>

      <div className="flex items-center gap-2">
        <div className="relative">
          <Search
            size={14}
            className="absolute left-2.5 top-1/2 -translate-y-1/2 text-chrome-bar-fg-dim pointer-events-none"
          />
          <input
            placeholder="Hledat všude... ⌘K"
            className="h-8 w-64 bg-chrome-search-bg border border-chrome-search-border text-chrome-bar-fg rounded pl-8 pr-3 text-xs placeholder:text-chrome-search-ph focus:outline-none focus:border-chrome-bar-accent transition-colors"
          />
        </div>
        <Tooltip content="Nápověda">
          <button
            data-testid="topbar-help-btn"
            className="h-8 w-8 rounded flex items-center justify-center text-chrome-bar-fg-dim hover:text-chrome-bar-fg-active hover:bg-chrome-bar-hover transition-colors"
          >
            <Info size={14} />
          </button>
        </Tooltip>
      </div>
    </div>
  );
};

export default AppTopbar;
